import { Component, OnInit, Input } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { AppService } from "../../../../services/app.service";
import { MasterService } from "../../../../services/master.service";
import { Subject } from "rxjs";
import { AjaxService } from "../../../../../../core/services/ajax.service";
import { Http } from "@angular/http";
import { takeUntil } from "rxjs/operators";


@Component({
  selector: 'app-dist-customer-detail',
  templateUrl: './dist-customer-detail.component.html',
  styleUrls: ['./dist-customer-detail.component.scss']
})
export class DistCustomerDetailComponent implements OnInit {
  @Input() parent: any;

  formGroup: FormGroup;
  formGroupErrors: any;

  translations: any;
  postalCodeList: any = [];
  pcFilterCtrl: FormControl = new FormControl();
  /** Subject that emits when the component has been destroyed. */
  private _onDestroy = new Subject<void>();
  searchFlag: boolean = true;
  invalidForm = true;
  showSaveButton : Boolean = true;
  pcRequired = false;
  constructor(
    private formBuilder: FormBuilder,
    public appService: AppService,
    private masterService: MasterService,
    private http: Http,
    private _ajaxService: AjaxService
  ) {
    this.showSaveButton = !(sessionStorage.getItem("ViewMode") == 'true');
    this.appService.showLoading();
    this.setPageTranslations();

    this.formGroupErrors = {
      C_Name: {},
      C_Address: {},
      City: {},
      Region: {},
      Canton:{},
      Country: {},
      C_HouseNo: {},
      C_Email: {}
    };   
   
  }

  ngOnInit() {
    this.loadFormGroup();
  
    this.pcFilterCtrl.valueChanges
    .debounceTime(400)
    .pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.filterPC();
    });  
     
    
    if((typeof this.parent.order.Id == 'undefined' || this.parent.order.Id == 0) && this.parent.order['PostalCode'] == ''){
      this.pcRequired = false;
      this.appService.hideLoading();
    }
    else{
      this.pcFilterCtrl.setValue(this.parent.order['PostalCode']);
    }
    

  }
  filterPC() {
    let search = this.pcFilterCtrl.value;
    if (search && search.length > 0) {
      
      this._ajaxService
        .GET("Master.svc/master/34/" 
        + (typeof this.parent.order.C_PostalCodeId != 'undefined' ? this.parent.order.C_PostalCodeId : '0') + "/0/"
        + (!search ? " " : search)+ "/0")
        .subscribe(response => {
          this.postalCodeList = JSON.parse(response.Data);
          this.pcRequired = this.parent.order.C_PostalCodeId > 0 ? false : true;
          if(this.parent.order.C_PostalCodeId > 0
            && !this.formGroup.invalid){
              this.appService.setFormValid(false);
            }
            else{
              this.appService.setFormValid(true);
            }
          
          this.appService.hideLoading();
        });
    }else {
      this.parent.order.C_PostalCodeId = 0;
      this.postalCodeList = [];
      this.pcRequired = true;
      if(this.parent.order.C_PostalCodeId > 0
        && !this.formGroup.invalid){
          this.appService.setFormValid(false);
        }
        else{
          this.appService.setFormValid(true);
        }
        this.appService.hideLoading();
    }
  }
  setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
  }
 
  apiFaillure(error): void {
    this.appService.showDialogue(
      this.translations.hdError,
      this.translations[error]
    );
  }
  onPCBlur(e){
    this.pcRequired =  this.parent.order.C_PostalCodeId  > 0 ? false : true;
  }
  onSelectionChanged(e){
    ;
    console.log(e);
  }
  changePostalCode(pcCodeId,pcDescription,pcCode) {
    ;
    if (this.parent.order.C_PostalCodeId != pcCodeId) {
      this.appService.showLoading();
 
      this.parent.order.C_PostalCodeId= pcCodeId;
      
      this.parent.order.PostalCode = pcDescription + ' (' + pcCode + ')';
      this.pcRequired = this.parent.order.C_PostalCodeId > 0 ? false : true;
      this.masterService
      .cccDetail(pcCodeId)
      .subscribe(
        res => this.changePostalCodeSuccess(res),
        error => this.apiFaillure(error)
      );
    }
    if(this.parent.order.C_PostalCodeId > 0
      && !this.formGroup.invalid){
        this.appService.setFormValid(false);
      }
      else{
        this.appService.setFormValid(true);
      }
  }

  changePostalCodeSuccess(res): void {
    this.appService.hideLoading();
    if (res.Data != null) {
      this.parent.order.City = JSON.parse(res.Data)[0]["City"];
      this.parent.order.Country = JSON.parse(res.Data)[0]["Country"];
      this.parent.order.Region = JSON.parse(res.Data)[0]["Region"];
      this.parent.order.Canton = JSON.parse(res.Data)[0]["Canton"];
    } else {
      this.apiFaillure(res.Message);
    }
  }
 
  loadFormGroup(){
    this.formGroup = this.formBuilder.group({
      C_Name: [{
        value: "",
        disabled: true
      }, Validators.required],
      C_Address: [{
        value: "",
        disabled: true
      }, Validators.required],
      C_HouseNo: [{ value: "", disabled: true }],
      // C_Email: [{value: "", disabled: true }, [Validators.pattern(/^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/)]],
      // C_Email: [{value: "", disabled: true }, , Validators.pattern(/)$/)],
      C_Email: [{value: "", disabled: !this.showSaveButton }, [Validators.pattern(/^([\w+-.%]+@[\w\-.]+\.[A-Za-z]{2,4};?)+$/)]],
      C_PostalCodeId: [{
        value: "",
        disabled: true
      }, Validators.required],
      City: [
        {
          value: "",
          disabled: true
        }
      ],
      Region: [
        {
          value: "",
          disabled: true
        }
      ],
      Canton: [
        {
          value: "",
          disabled: true
        }
      ],
      Country: [
        {
          value: "",
          disabled: true
        }
      ]
    });
    this.formGroup.valueChanges.subscribe(() => {
      this.formGroupErrors = this.appService.onFormValuesChanged(
        this.formGroup,
        this.formGroupErrors
      );
      this.appService.setFormValid(this.formGroup.invalid);
    });

  }
  changePostalCodeTab(e,postalCodeId){
    console.log(e.key.toString());
  }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor-order/distributor-order-edit-form/dist-customer-detail/dist-customer-detail.component.ts